;(function ($) {

$('#glossary-letter-left').click(
    function(){
        console.log("left");
        scrollGlossary(-60);}
);

$('#glossary-letter-right').click(
    function(){
        console.log("right");
        scrollGlossary(60);}
);

function scrollGlossary (input){
    var $scrollContainer = $('.glossary-letter-list .row .col-12');
    var $scrollLeft = $scrollContainer.scrollLeft();
    var $scrollNotZero = $scrollLeft % 60;
    if($scrollNotZero && input < 0){
        input = 0;
    }
    input = input + $scrollLeft - ($scrollNotZero);

    $scrollContainer.animate({scrollLeft: input});
}

}(jQuery));
